import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { DataService } from '../../../../shared/data/data.service';
import { SettingService } from '../../../../shared/settings/settings.service';
import { routes } from '../../../../shared/routes/routes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-top-bar',
  standalone: false,
  templateUrl: './header-top-bar.component.html',
  styleUrl: './header-top-bar.component.scss'
})
export class HeaderTopBarComponent implements OnInit {

  get selectedCountryLabel(): string {
  const found = this.supportedInfo.find(i => i.id === this.selectedCountryId);
  if (!found) return 'Select';
  const langName = this.getHotelLanguageName(found.hotelLanguage as any);
  return `${found.currency}${langName ? ' • ' + langName : ''}`;
  }

  onCountryChangeDropdown(selectedId: number) {
    this.selectedCountryId = selectedId;
    const selectedObj = this.supportedInfo.find(i => i.id === selectedId);
    if (selectedObj) {
      localStorage.setItem('selectedCountryInfo', JSON.stringify(selectedObj));
    this.router.navigate(['/home']);
    }
  }
  supportedInfo: Array<{ id: number; currency: string; hotelLanguage?: string; country: string; isDefault?: boolean }> = [];
  selectedCountryId: number | null = null;
  hotelLanguages: Array<{ languageCode?: string; language_code?: string; languageName?: string; language_name?: string }> = [];

  public routes = routes;
  @Input() base: string = '';
  @Input() page: string = ''
  @Input() isdark: boolean = false;
  @Input() islight: boolean = false;

  @Output() darkMode: EventEmitter<void> = new EventEmitter()

  constructor(
  public settings: SettingService,
  private readonly dataService: DataService,
  private router: Router
  ) {}

  ngOnInit(): void {
  this.dataService.getHotelLanguages().subscribe(langs => this.hotelLanguages = langs || []);
    this.dataService.getSupportedInfo().subscribe((info: any[]) => {
      this.supportedInfo = info;
      let selectedObj: any = null;
      const stored = localStorage.getItem('selectedCountryInfo');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          selectedObj = info.find(i => i.id === parsed.id) || null;
        } catch { /* ignore */ }
      }
      if (!selectedObj) {
        selectedObj = info.find(i => i.isDefault) || info[0];
      }
      if (selectedObj) {
        this.selectedCountryId = selectedObj.id;
        localStorage.setItem('selectedCountryInfo', JSON.stringify(selectedObj));
      }
    });
  }

  getHotelLanguageName(code?: string): string | null {
    if (!code) return null;
    const rec = this.hotelLanguages.find(l => (l.languageCode || (l as any).language_code) === code);
    return rec ? (rec.languageName || (rec as any).language_name || null) : null;
  }

  onCountryChange(event: any) {
    const selectedId = +event.target.value;
    this.selectedCountryId = selectedId;
    const selectedObj = this.supportedInfo.find(i => i.id === selectedId);
    if (selectedObj) {
      localStorage.setItem('selectedCountryInfo', JSON.stringify(selectedObj));
    this.router.navigate(['/home']);
    }
  }
}
